import React from 'react';
import { Link } from 'react-router-dom';

const ServicesOneHiringArea = () => {
    return (
        <>
            <section className="hiring-area pt-120 pb-120">
                <div className="container">
                    <div className="row no-gutters hire-bg-2">
                        <div className="col-xl-6 col-lg-6">
                            <div className="hire-img">
                                <img className="img" src="img/doctor/Dr. S. P. Gupta.jpg" alt="" />
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-6">
                            <div className="hire-text">
                                <h1>Dr. S. P. Gupta</h1>
                                <p>
                                    MBBS, MS (General Surgery) FMAS, FAIS. Ex SR SMH Agra
                                    <br />
                                    25 yrs of experience.
                                    <br />
                                    About 18000 surgeries.
                                </p>
                                <Link to="/contact"
                                    className="primary_btn btn-icon btn-icon-green ml-0"><span>+</span>Contact us</Link>
                            </div>
                        </div>
                    </div>
                    <div className="row no-gutters hire-bg">
                        <div className="col-xl-6 col-lg-6">
                            <div className="hire-text">
                                <h1>Dr. Pramedra Singh</h1>
                                <p>
                                    MBBS MS FMAS
                                    <br />
                                    Advanced GI & Laparoscopic Surgeon
                                    <br />
                                    More than 10000 laparoscopic surgery with 12 yr of experience.
                                </p>
                                <Link to="/contact"
                                    className="primary_btn btn-icon ml-0"><span>+</span>Contact Us</Link>
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-6">
                            <div className="hire-img">
                                <img className="img" src="img/doctor/Dr. Pramedra Singh.jpg" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default ServicesOneHiringArea;